import { PPMFeatures, Subscription } from "../../../store/Tenant";
import { RouteComponentProps, withRouter } from "react-router-dom";
import React from "react";
import { UserState } from "../../../store/User";
import { EntityType, IEditable } from "../../../entities/common";
import Spinner from "../../common/Spinner/Spinner";
import { Overlay } from "office-ui-fabric-react";
import * as analytics from '../../../analytics';
import PresentationMode from "./PresentationMode";

type OwnProps<TEntity> = {
    entity?: TEntity;
    isLoading?: boolean;
    isViewable?: boolean;
    entityType: EntityType;
    user: UserState;
    subscription: Subscription;
    url?: string;
};

type Props<TEntity> = OwnProps<TEntity> & RouteComponentProps<{ id: string }>;

const PresentationModeContainer = <TEntity extends IEditable>(props: React.PropsWithChildren<Props<TEntity>>) => {
    const { entity, isLoading, isViewable, url, subscription, user, entityType } = props;
    const [isEnabled, setIsEnabled] = React.useState<boolean>(!!user.preferences?.presentationMode);
    
    const isForce = !!props.location.state?.presentationMode;
    const isFeatureEnabled = Subscription.containsAny(subscription, [PPMFeatures.PresentationMode, PPMFeatures.PresentationModeUltra]);

    React.useEffect(() => {
        if (isFeatureEnabled && !!user.preferences?.presentationMode 
            && !!url && entity && isViewable && !isForce && !entity?.isEditable) {
                analytics.trackEvent("Open Presentation Mode (enabled by default)", user);
        }
    }, [entity]);

    if (!entity || isLoading) {
        return <Overlay>
            <Spinner />
        </Overlay>;
    }

    return <>
        {isFeatureEnabled && (isEnabled || isForce)
            && !!url && entity && isViewable && (isForce || !entity.isEditable)
                ? <PresentationMode 
                    {...props}
                    entityType={entityType} 
                    isForce={isForce}
                    setIsEnabled={setIsEnabled} />
                : props.children
        }
    </>
}

export default <TEntity extends IEditable>() => withRouter<React.PropsWithChildren<OwnProps<TEntity>>>(PresentationModeContainer);